module.exports = __webpack_public_path__ + "img/pinterest.88623193.svg";